module.exports = {
      id: "original-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#original-usage",
      toString: function () {
        return this.url;
      }
    }